"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyBoardEvents = exports.LocalStorageKeys = void 0;
var LocalStorageKeys;
(function (LocalStorageKeys) {
    LocalStorageKeys["AUTH_INVALIDATING_KEY"] = "auroraAuthentication.invalidating";
    LocalStorageKeys["AUTH_INVALIDATION_KEY"] = "auroraAuthentication.invalidate";
    LocalStorageKeys["INBOX_CONVERSATIONS_FILTER"] = "inbox-conversations-filter";
    LocalStorageKeys["PAGE_EDITOR_SESSION_KEY"] = "pageEditor.session";
    LocalStorageKeys["ANALYTICS_DASHBOARD_CONFIGS"] = "analytics.dashboard.configs";
    LocalStorageKeys["ANALYTICS_DASHBOARD_FILTERS"] = "analytics.dashboard.filters";
    LocalStorageKeys["ANALYTICS_DATETIME_VALUE"] = "analytics.datetime.value";
    LocalStorageKeys["ANALYTICS_REPORTS_CONFIGS"] = "analytics.reports.configs";
    LocalStorageKeys["ANALYTICS_REPORTS_DATE_RANGE"] = "analytics.reports.date.range";
    LocalStorageKeys["ANALYTICS_WIDGET_CONFIG"] = "analytics.widget.config";
    LocalStorageKeys["ANALYTICS_REPORTS_FILTERS"] = "analytics.reports.filters";
    LocalStorageKeys["USER_NOTIFICATION_READ_TIMESTAMP"] = "user.notification.read.timestamp";
    LocalStorageKeys["SSO_REGISTRATION_MODAL"] = "sso.registration.modal";
    LocalStorageKeys["ANONYMOUS_USER_ACTION_KEY"] = "anonymousUser.action";
    LocalStorageKeys["RSVP_RESPONSE"] = "rsvp.response";
    LocalStorageKeys["ANALYTICS_DASHBOARD_CONVERSATIONSTYLE"] = "analytics.dashboard.conversationStyle";
    LocalStorageKeys["MESSSAGE_SESSION_KEY"] = "message.session";
    LocalStorageKeys["ANONYMOUS_USER_ABUSE_REPORT_KEY"] = "anonymousUserAbuseReport.action";
    LocalStorageKeys["AI_SEARCH_CHAT_UNREAD_COUNT"] = "aichat.unreadCount";
    LocalStorageKeys["SDK_BANNER_MINIMIZED"] = "sdkBannerMinimized";
    LocalStorageKeys["REDIRECT_RULE_MAP"] = "redirectRuleMap";
    LocalStorageKeys["VALUE_SURVEY_VISIT_START_TIME"] = "valueSurveyVisitStartTime";
})(LocalStorageKeys || (exports.LocalStorageKeys = LocalStorageKeys = {}));
var KeyBoardEvents;
(function (KeyBoardEvents) {
    KeyBoardEvents["ENTER"] = "Enter";
    KeyBoardEvents["TAB"] = "Tab";
    KeyBoardEvents["ARROW_UP"] = "ArrowUp";
    KeyBoardEvents["ARROW_DOWN"] = "ArrowDown";
    KeyBoardEvents["ARROW_LEFT"] = "ArrowLeft";
    KeyBoardEvents["ARROW_RIGHT"] = "ArrowRight";
    KeyBoardEvents["ESCAPE"] = "Escape";
    KeyBoardEvents["SPACE"] = " ";
})(KeyBoardEvents || (exports.KeyBoardEvents = KeyBoardEvents = {}));
//# sourceMappingURL=enums.js.map